import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment-timezone'
import DateTimeField from 'components/Common/DateTimeField'
import { eventZoneLabel } from './eventCreationForm'

const format = 'YYYY-MM-DDTHH:mm'
const display = (value, zone) => value && moment(value).isValid() ? moment(value).tz(zone).format(format) : ''
function occurrences(value, zone) {
  const wall = moment.utc(value, format, true), timezone = moment.tz.zone(zone)
  if (!wall.isValid() || !timezone) return []
  return [...new Set(timezone.offsets)].map(offset => wall.valueOf() + offset * 60000)
    .filter(instant => moment(instant).tz(zone).format(format) === value).sort((a, b) => a - b).map(instant => new Date(instant).toISOString())
}
export default function EventDateTime({ id, label, value, timezone = 'UTC', onChange, error, required }) {
  const [local, setLocal] = useState(() => display(value, timezone))
  const sent = useRef(value)
  const previousZone = useRef(timezone)
  useEffect(() => {
    if (sent.current !== value || previousZone.current !== timezone) setLocal(display(value, timezone))
    previousZone.current = timezone; sent.current = value
  }, [value, timezone])
  const choices = occurrences(local, timezone)
  const selected = choices.find(instant => value && new Date(instant).getTime() === new Date(value).getTime()) || ''
  const problem = local && choices.length === 0 ? 'This local time does not exist in ' + timezone + '.'
    : choices.length > 1 && !selected ? 'This local time occurs twice. Choose the intended occurrence.' : ''
  const change = instant => { sent.current = instant; onChange(instant) }
  return <div className="event-edit-field"><label htmlFor={id}>{label}{required ? ' *' : ''}</label>
    {/* The CP's day / hour picker (P24, Tudor 2026-10-24): the same wall time string as the native field it replaces. */}
    <DateTimeField id={id} mode="datetime" value={local} zoneLabel={eventZoneLabel(timezone)} aria-invalid={Boolean(problem || error)} aria-describedby={id + '-time-help'} onChange={event => {
      const next = event.target.value, possible = occurrences(next, timezone)
      setLocal(next); change(possible.length === 1 ? possible[0] : null)
    }} />
    {choices.length > 1 && <><label htmlFor={id + '-occurrence'}>{label} occurrence</label><select id={id + '-occurrence'} className="form-control" value={selected} onChange={event => change(event.target.value || null)}>
      <option value="">Choose occurrence</option>{choices.map((instant, index) => <option key={instant} value={instant}>{index ? 'Second' : 'First'} occurrence · UTC{moment(instant).tz(timezone).format('Z')}</option>)}
    </select></>}
    <small id={id + '-time-help'} className={problem || error ? 'text-danger' : 'text-muted'}>{problem || error || timezone}</small>
  </div>
}
